import { useSelector } from "react-redux";
import {type RootState } from "../../../../store";
import useConstructionsNewFiltersHook from "./hooks/useConstructionsNewFiltersHook";
import styles from "./constructionsNewFilters.module.scss";
import { ComboBox, DatePicker, DefaultButton, SearchBox } from "@fluentui/react";

const ConstructionsNewFilters: React.FunctionComponent = () => {
    const {tags, locationCodes, createdBy} = useSelector((state: RootState) => state.constructionsNew);
    const {
        filters,
        handleFilterChange,
        handleFiltersClear,
        handleFormSubmit,
        handleFormattedDate,
    } = useConstructionsNewFiltersHook();

    return (
        <form className={styles.form} onSubmit={handleFormSubmit}>
          <SearchBox
            name="name"
            className={styles.name}
            value={filters.name ?? ""}
            placeholder="Search by name"
            onClear={() => {
              handleFilterChange(undefined, "name");
            }}
            onChange={(_, newValue) => {
              handleFilterChange(newValue, "name");
              return undefined;
            }}
          />
          <DatePicker
            placeholder="From"
            className={styles.from}
            value={filters.from !== undefined ? new Date(filters.from) : undefined}
            onSelectDate={date => {
              handleFilterChange(date?.toString(), "from");
            }}
            formatDate={handleFormattedDate}
          />
          <DatePicker
            placeholder="To"
            className={styles.to}
            value={filters.to !== undefined ? new Date(filters.to) : undefined}
            onSelectDate={date => {
              handleFilterChange(date?.toString(), "to");
            }}
            formatDate={handleFormattedDate}
          />
    
          {/* Note: TagPicker should have been used but there is an active FluentUI bug that makes in un-usable on the current version of React. */}
          <ComboBox
            placeholder="Select tags"
            className={styles.tags}
            multiSelect
            options={tags}
            selectedKey={filters.tags}
             // @ts-expect-error - This is a known issue with FluentUI ComboBox when using multiSelect. It does not recognize defaultSelectedKeys as a valid prop, even though it works as expected.
            defaultSelectedKeys={filters.tags ?? []}
            autoComplete={"on"}
            allowFreeform={true}
            onChange={(_, options) => {
              if(!options) return;

              const newTags = options.selected
                ? Array.from(new Set([...(filters.tags ?? []), String(options.key)]))
                : (filters.tags ?? []).filter(tag => tag !== String(options.key));

              handleFilterChange(newTags, "tags");
            }}
          />
          {/* Note: TagPicker should have been used but there is an active FluentUI bug that makes in un-usable on the current version of React. */}
          <ComboBox
            placeholder="Select location codes"
            className={styles.codes}
            multiSelect
            options={locationCodes}
            selectedKey={filters.locationCodes}
             // @ts-expect-error - This is a known issue with FluentUI ComboBox when using multiSelect. It does not recognize defaultSelectedKeys as a valid prop, even though it works as expected.
            defaultSelectedKeys={filters.locationCodes ?? []}
            autoComplete={"on"}
            allowFreeform={true}
            onChange={(_, options) => {
              if(!options) return;

              const newLocationCodes = options.selected
                ? Array.from(new Set([...(filters.locationCodes ?? []), String(options.key)]))
                : (filters.locationCodes ?? []).filter(code => code !== String(options.key));
              handleFilterChange(newLocationCodes, "locationCodes");
            }}
          />
          {/* Note: TagPicker should have been used but there is an active FluentUI bug that makes in un-usable on the current version of React. */}
          <ComboBox
            placeholder="Select created by"
            className={styles.codes}
            multiSelect
            options={createdBy}
            selectedKey={filters.createdBy}
             // @ts-expect-error - This is a known issue with FluentUI ComboBox when using multiSelect. It does not recognize defaultSelectedKeys as a valid prop, even though it works as expected.
            defaultSelectedKeys={filters.createdBy ?? []}
            autoComplete={"on"}
            allowFreeform={true}
            onChange={(_, options) => {
              if(!options) return;
              
              const newCreatedBy = options.selected
                ? Array.from(new Set([...(filters.createdBy ?? []), String(options.key)]))
                : (filters.createdBy ?? []).filter(user => user !== String(options.key));
              handleFilterChange(newCreatedBy, "createdBy");
            }}
          />
          {/* <PrimaryButton text="Search" type="submit" className={styles.button} /> */}
          <DefaultButton
            text="Clear"
            type="button"
            className={styles.button}
            onClick={handleFiltersClear}
          />
        </form>
      );
};

export default ConstructionsNewFilters;